<app-menu></app-menu>

<div class="mystore-page">
  <div class="page-guide">CONTROLPS / MY STORE</div>

  <section class="mystore-hero">
    <div>
      <h1>My Store</h1>
      <p>Gestão integrada de lojas, clientes, catálogo, estoque, vendas, compras, caixa e relatórios.</p>
    </div>
    <div class="mystore-hero__actions">
      <button mat-raised-button color="primary" type="button" (click)="openSaleModal()">
        <mat-icon>point_of_sale</mat-icon>
        Nova venda
      </button>
      <button mat-stroked-button type="button" (click)="openBudgetModal()">
        <mat-icon>request_quote</mat-icon>
        Novo orçamento
      </button>
      <button mat-stroked-button type="button" (click)="openStockMovementModal()">
        <mat-icon>warehouse</mat-icon>
        Movimentar estoque
      </button>
    </div>
  </section>

  <nav class="cp-tabs mystore-tabs">
    <button *ngFor="let tab of tabs" type="button" [class.active]="activeTab === tab.key" (click)="switchTab(tab.key)">
      <mat-icon>{{ tab.icon }}</mat-icon>
      {{ tab.label }}
    </button>
  </nav>

  <section class="mystore-feedback" *ngIf="feedback || errorMessage">
    <div class="feedback success" *ngIf="feedback">{{ feedback }}</div>
    <div class="feedback error" *ngIf="errorMessage">{{ errorMessage }}</div>
  </section>

  <section class="mystore-dashboard" *ngIf="activeTab === 'dashboard'">
    <article class="metric-card">
      <span>Lojas</span>
      <strong>{{ dashboardSummary.stores_count || 0 }}</strong>
      <small>Estrutura matriz e filial</small>
    </article>
    <article class="metric-card">
      <span>Clientes</span>
      <strong>{{ dashboardSummary.clients_count || 0 }}</strong>
      <small>Base ativa do módulo</small>
    </article>
    <article class="metric-card">
      <span>Itens</span>
      <strong>{{ dashboardSummary.items_count || 0 }}</strong>
      <small>Produtos e serviços</small>
    </article>
    <article class="metric-card">
      <span>Orçamentos abertos</span>
      <strong>{{ dashboardSummary.open_budgets || 0 }}</strong>
      <small>Em rascunho, enviados ou aprovados</small>
    </article>
    <article class="metric-card">
      <span>Faturamento</span>
      <strong>{{ asCurrency(dashboardSummary.sales_revenue) }}</strong>
      <small>Vendas não canceladas</small>
    </article>
    <article class="metric-card">
      <span>Compras</span>
      <strong>{{ asCurrency(dashboardSummary.purchase_total) }}</strong>
      <small>Total comprado</small>
    </article>

    <article class="panel dashboard-panel dashboard-panel--chart">
      <header>
        <div>
          <h3>Vendas por mês</h3>
          <small>Evolução consolidada do faturamento.</small>
        </div>
      </header>
      <div class="monthly-chart" *ngIf="dashboardMonthlySales.length; else noMonthlySales">
        <div class="monthly-chart__item" *ngFor="let item of dashboardMonthlySales">
          <div class="monthly-chart__bar-wrap">
            <div class="monthly-chart__bar" [style.height.%]="item.max_value ? ((item.total_amount || 0) / item.max_value) * 100 : 0"></div>
          </div>
          <strong>{{ item.month_label }}</strong>
          <small>{{ asCurrency(item.total_amount) }}</small>
        </div>
      </div>
      <ng-template #noMonthlySales>
        <div class="empty">Sem vendas registradas no período.</div>
      </ng-template>
    </article>

    <article class="panel dashboard-panel">
      <header>
        <div>
          <h3>Resumo operacional</h3>
          <small>Indicadores rápidos para gestão diária.</small>
        </div>
      </header>
      <div class="summary-grid">
        <div>
          <span>Vendas cadastradas</span>
          <strong>{{ dashboardSummary.sales_count || 0 }}</strong>
        </div>
        <div>
          <span>Compras cadastradas</span>
          <strong>{{ dashboardSummary.purchases_count || 0 }}</strong>
        </div>
        <div>
          <span>Margem bruta estimada</span>
          <strong>{{ asCurrency((dashboardSummary.sales_revenue || 0) - (dashboardSummary.purchase_total || 0)) }}</strong>
        </div>
        <div>
          <span>Ticket médio</span>
          <strong>{{ asCurrency((dashboardSummary.sales_count || 0) ? (dashboardSummary.sales_revenue || 0) / dashboardSummary.sales_count : 0) }}</strong>
        </div>
      </div>
    </article>
  </section>

  <section class="module-section" *ngIf="activeTab === 'stores'">
    <article class="panel">
      <header class="panel-header">
        <div>
          <h3>Lojas</h3>
          <small>Cadastre matriz, filiais, gerente e vínculo de usuários por loja.</small>
        </div>
        <div class="panel-header__actions">
          <mat-form-field appearance="outline" class="cp-field-mat cp-search-field cp-search-field--table">
            <mat-label>Buscar loja</mat-label>
            <mat-icon matPrefix>search</mat-icon>
            <input matInput [(ngModel)]="filters.stores.q" (ngModelChange)="filters.stores.page = 1; loadStores()" placeholder="Nome, código ou cidade">
          </mat-form-field>
          <button mat-raised-button color="primary" type="button" (click)="openStoreModal()">
            <mat-icon>add_business</mat-icon>
            Nova loja
          </button>
        </div>
      </header>

      <div class="table-card">
        <table class="data-table">
          <thead>
            <tr>
              <th>Loja</th>
              <th>Tipo</th>
              <th>Gerente</th>
              <th>Cidade</th>
              <th>Status</th>
              <th class="actions-col">Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let store of stores">
              <td>
                <strong>{{ store.name }}</strong>
                <small>{{ store.code || 'Sem código' }}</small>
              </td>
              <td>{{ store.store_type === 'MATRIX' ? 'Matriz' : 'Filial' }}</td>
              <td>{{ store.manager_user_name || '-' }}</td>
              <td>{{ store.address_city || '-' }}<span *ngIf="store.address_state"> / {{ store.address_state }}</span></td>
              <td>
                <span class="status-pill" [class.is-inactive]="!store.active">{{ store.active ? 'Ativa' : 'Inativa' }}</span>
              </td>
              <td class="actions-col">
                <button mat-stroked-button type="button" (click)="openStoreUsersModal(store)">Usuários</button>
                <button mat-stroked-button type="button" (click)="openStoreModal(store)">Editar</button>
                <button mat-stroked-button color="warn" type="button" (click)="deleteStore(store)">Excluir</button>
              </td>
            </tr>
            <tr *ngIf="!stores.length">
              <td colspan="6" class="empty-row">Nenhuma loja cadastrada.</td>
            </tr>
          </tbody>
        </table>
      </div>

      <footer class="pager">
        <span>{{ storesTotal }} registro(s)</span>
        <div>
          <button mat-stroked-button type="button" (click)="prevPage(filters.stores, loadStores.bind(this))" [disabled]="filters.stores.page <= 1">Anterior</button>
          <span>Página {{ filters.stores.page }}</span>
          <button mat-stroked-button type="button" (click)="nextPage(storesTotal, filters.stores, loadStores.bind(this))" [disabled]="!hasNext(storesTotal, filters.stores)">Próxima</button>
        </div>
      </footer>
    </article>
  </section>

  <section class="module-section" *ngIf="activeTab === 'clients'">
    <article class="panel">
      <header class="panel-header">
        <div>
          <h3>Clientes</h3>
          <small>Base comercial para orçamentos e vendas.</small>
        </div>
        <div class="panel-header__actions">
          <mat-form-field appearance="outline" class="cp-field-mat cp-search-field cp-search-field--table">
            <mat-label>Buscar cliente</mat-label>
            <mat-icon matPrefix>search</mat-icon>
            <input matInput [(ngModel)]="filters.clients.q" (ngModelChange)="filters.clients.page = 1; loadClients()" placeholder="Nome, documento, e-mail">
          </mat-form-field>
          <button mat-raised-button color="primary" type="button" (click)="openClientModal()">
            <mat-icon>person_add</mat-icon>
            Novo cliente
          </button>
        </div>
      </header>

      <div class="table-card">
        <table class="data-table">
          <thead>
            <tr>
              <th>Cliente</th>
              <th>Documento</th>
              <th>Contato</th>
              <th>Localidade</th>
              <th>Status</th>
              <th class="actions-col">Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let client of clients">
              <td>
                <strong>{{ client.name }}</strong>
                <small>{{ client.code || 'Sem código' }}</small>
              </td>
              <td>{{ client.document_number || '-' }}</td>
              <td>{{ client.email || client.phone || client.mobile_phone || '-' }}</td>
              <td>{{ client.address_city || '-' }}<span *ngIf="client.address_state"> / {{ client.address_state }}</span></td>
              <td><span class="status-pill" [class.is-inactive]="!client.active">{{ client.active ? 'Ativo' : 'Inativo' }}</span></td>
              <td class="actions-col">
                <button mat-stroked-button type="button" (click)="openClientModal(client)">Editar</button>
                <button mat-stroked-button color="warn" type="button" (click)="deleteClient(client)">Excluir</button>
              </td>
            </tr>
            <tr *ngIf="!clients.length">
              <td colspan="6" class="empty-row">Nenhum cliente cadastrado.</td>
            </tr>
          </tbody>
        </table>
      </div>

      <footer class="pager">
        <span>{{ clientsTotal }} registro(s)</span>
        <div>
          <button mat-stroked-button type="button" (click)="prevPage(filters.clients, loadClients.bind(this))" [disabled]="filters.clients.page <= 1">Anterior</button>
          <span>Página {{ filters.clients.page }}</span>
          <button mat-stroked-button type="button" (click)="nextPage(clientsTotal, filters.clients, loadClients.bind(this))" [disabled]="!hasNext(clientsTotal, filters.clients)">Próxima</button>
        </div>
      </footer>
    </article>
  </section>

  <section class="module-section" *ngIf="activeTab === 'catalog'">
    <div class="split-layout">
      <article class="panel">
        <header class="panel-header">
          <div>
            <h3>Categorias</h3>
            <small>Estruture o catálogo por grupos de produtos e serviços.</small>
          </div>
          <button mat-raised-button color="primary" type="button" (click)="openCategoryModal()">
            <mat-icon>add</mat-icon>
            Nova categoria
          </button>
        </header>

        <div class="table-card compact">
          <table class="data-table">
            <thead>
              <tr>
                <th>Nome</th>
                <th>Descrição</th>
                <th class="actions-col">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let category of categories">
                <td>{{ category.name }}</td>
                <td>{{ category.description || '-' }}</td>
                <td class="actions-col">
                  <button mat-stroked-button type="button" (click)="openCategoryModal(category)">Editar</button>
                  <button mat-stroked-button color="warn" type="button" (click)="deleteCategory(category)">Excluir</button>
                </td>
              </tr>
              <tr *ngIf="!categories.length">
                <td colspan="3" class="empty-row">Nenhuma categoria cadastrada.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </article>

      <article class="panel">
        <header class="panel-header">
          <div>
            <h3>Itens do catálogo</h3>
            <small>Produtos e serviços com preços, custo e controle de estoque.</small>
          </div>
          <div class="panel-header__actions">
            <mat-form-field appearance="outline" class="cp-field-mat cp-search-field cp-search-field--table">
              <mat-label>Buscar item</mat-label>
              <mat-icon matPrefix>search</mat-icon>
              <input matInput [(ngModel)]="filters.items.q" (ngModelChange)="filters.items.page = 1; loadItems()" placeholder="Nome, SKU ou código">
            </mat-form-field>
            <mat-form-field appearance="outline" class="cp-field-mat cp-search-field cp-search-field--table filter-small">
              <mat-label>Tipo</mat-label>
              <mat-select [(ngModel)]="filters.items.item_type" (selectionChange)="filters.items.page = 1; loadItems()">
                <mat-option value="">Todos</mat-option>
                <mat-option value="PRODUCT">Produto</mat-option>
                <mat-option value="SERVICE">Serviço</mat-option>
              </mat-select>
            </mat-form-field>
            <button mat-raised-button color="primary" type="button" (click)="openItemModal()">
              <mat-icon>add</mat-icon>
              Novo item
            </button>
          </div>
        </header>

        <div class="table-card">
          <table class="data-table">
            <thead>
              <tr>
                <th>Item</th>
                <th>Tipo</th>
                <th>Categoria</th>
                <th>Custo</th>
                <th>Venda</th>
                <th>Estoque</th>
                <th class="actions-col">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of items">
                <td>
                  <strong>{{ item.name }}</strong>
                  <small>{{ item.sku || item.code || 'Sem identificação' }}</small>
                </td>
                <td>{{ item.item_type === 'PRODUCT' ? 'Produto' : 'Serviço' }}</td>
                <td>{{ item.category_name || '-' }}</td>
                <td>{{ asCurrency(item.cost_price) }}</td>
                <td>{{ asCurrency(item.sale_price) }}</td>
                <td>{{ item.stock_enabled ? 'Controlado' : 'Não controlado' }}</td>
                <td class="actions-col">
                  <button mat-stroked-button type="button" (click)="openItemModal(item)">Editar</button>
                  <button mat-stroked-button color="warn" type="button" (click)="deleteItem(item)">Excluir</button>
                </td>
              </tr>
              <tr *ngIf="!items.length">
                <td colspan="7" class="empty-row">Nenhum item cadastrado.</td>
              </tr>
            </tbody>
          </table>
        </div>

        <footer class="pager">
          <span>{{ itemsTotal }} registro(s)</span>
          <div>
            <button mat-stroked-button type="button" (click)="prevPage(filters.items, loadItems.bind(this))" [disabled]="filters.items.page <= 1">Anterior</button>
            <span>Página {{ filters.items.page }}</span>
            <button mat-stroked-button type="button" (click)="nextPage(itemsTotal, filters.items, loadItems.bind(this))" [disabled]="!hasNext(itemsTotal, filters.items)">Próxima</button>
          </div>
        </footer>
      </article>
    </div>

    <article class="panel">
      <header class="panel-header">
        <div>
          <h3>Fornecedores</h3>
          <small>Base de compras e reposição de estoque.</small>
        </div>
        <div class="panel-header__actions">
          <mat-form-field appearance="outline" class="cp-field-mat cp-search-field cp-search-field--table">
            <mat-label>Buscar fornecedor</mat-label>
            <mat-icon matPrefix>search</mat-icon>
            <input matInput [(ngModel)]="filters.suppliers.q" (ngModelChange)="filters.suppliers.page = 1; loadSuppliers()" placeholder="Nome, documento ou e-mail">
          </mat-form-field>
          <button mat-raised-button color="primary" type="button" (click)="openSupplierModal()">
            <mat-icon>add_business</mat-icon>
            Novo fornecedor
          </button>
        </div>
      </header>
      <div class="table-card">
        <table class="data-table">
          <thead>
            <tr>
              <th>Fornecedor</th>
              <th>Documento</th>
              <th>Contato</th>
              <th>Responsável</th>
              <th class="actions-col">Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let supplier of suppliers">
              <td>{{ supplier.name }}</td>
              <td>{{ supplier.document_number || '-' }}</td>
              <td>{{ supplier.email || supplier.phone || '-' }}</td>
              <td>{{ supplier.contact_name || '-' }}</td>
              <td class="actions-col">
                <button mat-stroked-button type="button" (click)="openSupplierModal(supplier)">Editar</button>
                <button mat-stroked-button color="warn" type="button" (click)="deleteSupplier(supplier)">Excluir</button>
              </td>
            </tr>
            <tr *ngIf="!suppliers.length">
              <td colspan="5" class="empty-row">Nenhum fornecedor cadastrado.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </article>
  </section>

  <section class="module-section" *ngIf="activeTab === 'stock'">
    <article class="panel">
      <header class="panel-header">
        <div>
          <h3>Estoque por loja</h3>
          <small>Saldo consolidado e histórico de movimentações.</small>
        </div>
        <div class="panel-header__actions">
          <mat-form-field appearance="outline" class="cp-field-mat cp-search-field cp-search-field--table filter-small">
            <mat-label>Loja</mat-label>
            <mat-select [(ngModel)]="filters.stock.store_id" (selectionChange)="loadStock()">
              <mat-option value="">Todas</mat-option>
              <mat-option *ngFor="let store of lookups.stores" [value]="store.id">{{ store.name }}</mat-option>
            </mat-select>
          </mat-form-field>
          <button mat-raised-button color="primary" type="button" (click)="openStockMovementModal()">
            <mat-icon>sync_alt</mat-icon>
            Nova movimentação
          </button>
        </div>
      </header>

      <div class="split-layout">
        <div class="table-card">
          <div class="table-card__title">Posição atual</div>
          <table class="data-table">
            <thead>
              <tr>
                <th>Loja</th>
                <th>Item</th>
                <th>Tipo</th>
                <th>Saldo</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of stockPositions">
                <td>{{ row.store_name }}</td>
                <td>{{ row.item_name }}</td>
                <td>{{ row.item_type === 'PRODUCT' ? 'Produto' : 'Serviço' }}</td>
                <td>{{ row.balance || 0 }}</td>
              </tr>
              <tr *ngIf="!stockPositions.length">
                <td colspan="4" class="empty-row">Sem posição de estoque para o filtro selecionado.</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="table-card">
          <div class="table-card__title">Movimentações</div>
          <table class="data-table">
            <thead>
              <tr>
                <th>Data</th>
                <th>Loja</th>
                <th>Item</th>
                <th>Tipo</th>
                <th>Quantidade</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of stockMovements">
                <td>{{ row.created_at | date:'dd/MM/yyyy HH:mm' }}</td>
                <td>{{ row.store_name }}</td>
                <td>{{ row.item_name }}</td>
                <td>{{ row.movement_type }}</td>
                <td>{{ row.quantity }}</td>
              </tr>
              <tr *ngIf="!stockMovements.length">
                <td colspan="5" class="empty-row">Nenhuma movimentação registrada.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </article>
  </section>

  <section class="module-section" *ngIf="activeTab === 'budgets'">
    <article class="panel">
      <header class="panel-header">
        <div>
          <h3>Orçamentos</h3>
          <small>Cadastre propostas e converta em vendas quando aprovadas.</small>
        </div>
        <button mat-raised-button color="primary" type="button" (click)="openBudgetModal()">
          <mat-icon>add</mat-icon>
          Novo orçamento
        </button>
      </header>

      <div class="table-card">
        <table class="data-table">
          <thead>
            <tr>
              <th>Código</th>
              <th>Loja</th>
              <th>Cliente</th>
              <th>Status</th>
              <th>Total</th>
              <th>Validade</th>
              <th class="actions-col">Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let budget of budgets">
              <td>{{ budget.code || ('#' + budget.id) }}</td>
              <td>{{ budget.store_name }}</td>
              <td>{{ budget.client_name || '-' }}</td>
              <td>{{ budget.status }}</td>
              <td>{{ asCurrency(budget.total_amount) }}</td>
              <td>{{ budget.valid_until ? (budget.valid_until | date:'dd/MM/yyyy') : '-' }}</td>
              <td class="actions-col">
                <button mat-stroked-button type="button" (click)="openBudgetModal(budget)">Editar</button>
                <button mat-stroked-button type="button" (click)="convertBudget(budget)" [disabled]="budget.status === 'CONVERTED'">Converter</button>
                <button mat-stroked-button color="warn" type="button" (click)="deleteBudget(budget)">Excluir</button>
              </td>
            </tr>
            <tr *ngIf="!budgets.length">
              <td colspan="7" class="empty-row">Nenhum orçamento cadastrado.</td>
            </tr>
          </tbody>
        </table>
      </div>

      <footer class="pager">
        <span>{{ budgetsTotal }} registro(s)</span>
        <div>
          <button mat-stroked-button type="button" (click)="prevPage(filters.budgets, loadBudgets.bind(this))" [disabled]="filters.budgets.page <= 1">Anterior</button>
          <span>Página {{ filters.budgets.page }}</span>
          <button mat-stroked-button type="button" (click)="nextPage(budgetsTotal, filters.budgets, loadBudgets.bind(this))" [disabled]="!hasNext(budgetsTotal, filters.budgets)">Próxima</button>
        </div>
      </footer>
    </article>
  </section>

  <section class="module-section" *ngIf="activeTab === 'sales'">
    <article class="panel">
      <header class="panel-header">
        <div>
          <h3>Vendas</h3>
          <small>Registro das vendas, itens e pagamentos recebidos.</small>
        </div>
        <button mat-raised-button color="primary" type="button" (click)="openSaleModal()">
          <mat-icon>add</mat-icon>
          Nova venda
        </button>
      </header>

      <div class="table-card">
        <table class="data-table">
          <thead>
            <tr>
              <th>Código</th>
              <th>Loja</th>
              <th>Cliente</th>
              <th>Status</th>
              <th>Total</th>
              <th>Pago</th>
              <th class="actions-col">Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let sale of sales">
              <td>{{ sale.code || ('#' + sale.id) }}</td>
              <td>{{ sale.store_name }}</td>
              <td>{{ sale.client_name || '-' }}</td>
              <td>{{ sale.status }}</td>
              <td>{{ asCurrency(sale.total_amount) }}</td>
              <td>{{ asCurrency(sale.paid_amount) }}</td>
              <td class="actions-col">
                <button mat-stroked-button type="button" (click)="openSaleModal(sale)">Editar</button>
                <button mat-stroked-button type="button" (click)="openPaymentModal(sale)">Pagamento</button>
                <button mat-stroked-button color="warn" type="button" (click)="deleteSale(sale)">Excluir</button>
              </td>
            </tr>
            <tr *ngIf="!sales.length">
              <td colspan="7" class="empty-row">Nenhuma venda cadastrada.</td>
            </tr>
          </tbody>
        </table>
      </div>

      <footer class="pager">
        <span>{{ salesTotal }} registro(s)</span>
        <div>
          <button mat-stroked-button type="button" (click)="prevPage(filters.sales, loadSales.bind(this))" [disabled]="filters.sales.page <= 1">Anterior</button>
          <span>Página {{ filters.sales.page }}</span>
          <button mat-stroked-button type="button" (click)="nextPage(salesTotal, filters.sales, loadSales.bind(this))" [disabled]="!hasNext(salesTotal, filters.sales)">Próxima</button>
        </div>
      </footer>
    </article>
  </section>

  <section class="module-section" *ngIf="activeTab === 'purchases'">
    <article class="panel">
      <header class="panel-header">
        <div>
          <h3>Compras</h3>
          <small>Gestão de compras por loja e fornecedor.</small>
        </div>
        <button mat-raised-button color="primary" type="button" (click)="openPurchaseModal()">
          <mat-icon>add</mat-icon>
          Nova compra
        </button>
      </header>

      <div class="table-card">
        <table class="data-table">
          <thead>
            <tr>
              <th>Código</th>
              <th>Loja</th>
              <th>Fornecedor</th>
              <th>Status</th>
              <th>Total</th>
              <th>Data</th>
              <th class="actions-col">Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let purchase of purchases">
              <td>{{ purchase.code || ('#' + purchase.id) }}</td>
              <td>{{ purchase.store_name }}</td>
              <td>{{ purchase.supplier_name || '-' }}</td>
              <td>{{ purchase.status }}</td>
              <td>{{ asCurrency(purchase.total_amount) }}</td>
              <td>{{ purchase.purchased_at ? (purchase.purchased_at | date:'dd/MM/yyyy HH:mm') : '-' }}</td>
              <td class="actions-col">
                <button mat-stroked-button type="button" (click)="openPurchaseModal(purchase)">Editar</button>
                <button mat-stroked-button color="warn" type="button" (click)="deletePurchase(purchase)">Excluir</button>
              </td>
            </tr>
            <tr *ngIf="!purchases.length">
              <td colspan="7" class="empty-row">Nenhuma compra cadastrada.</td>
            </tr>
          </tbody>
        </table>
      </div>

      <footer class="pager">
        <span>{{ purchasesTotal }} registro(s)</span>
        <div>
          <button mat-stroked-button type="button" (click)="prevPage(filters.purchases, loadPurchases.bind(this))" [disabled]="filters.purchases.page <= 1">Anterior</button>
          <span>Página {{ filters.purchases.page }}</span>
          <button mat-stroked-button type="button" (click)="nextPage(purchasesTotal, filters.purchases, loadPurchases.bind(this))" [disabled]="!hasNext(purchasesTotal, filters.purchases)">Próxima</button>
        </div>
      </footer>
    </article>
  </section>

  <section class="module-section" *ngIf="activeTab === 'cash'">
    <article class="panel">
      <header class="panel-header">
        <div>
          <h3>Caixa</h3>
          <small>Abertura, fechamento e movimentações financeiras por loja.</small>
        </div>
        <button mat-raised-button color="primary" type="button" (click)="openCashSessionModal()">
          <mat-icon>lock_open</mat-icon>
          Abrir caixa
        </button>
      </header>

      <div class="table-card">
        <table class="data-table">
          <thead>
            <tr>
              <th>Loja</th>
              <th>Status</th>
              <th>Abertura</th>
              <th>Fechamento</th>
              <th>Esperado</th>
              <th class="actions-col">Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let session of cashSessions">
              <td>{{ session.store_name }}</td>
              <td>{{ session.status === 'OPEN' ? 'Aberto' : 'Fechado' }}</td>
              <td>{{ session.opened_at | date:'dd/MM/yyyy HH:mm' }}</td>
              <td>{{ session.closed_at ? (session.closed_at | date:'dd/MM/yyyy HH:mm') : '-' }}</td>
              <td>{{ asCurrency(session.expected_amount) }}</td>
              <td class="actions-col">
                <button mat-stroked-button type="button" (click)="openCashMovements(session)">Movimentos</button>
                <button mat-stroked-button type="button" (click)="closeCashSession(session)" [disabled]="session.status !== 'OPEN'">Fechar</button>
              </td>
            </tr>
            <tr *ngIf="!cashSessions.length">
              <td colspan="6" class="empty-row">Nenhum caixa registrado.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </article>
  </section>

  <section class="module-section" *ngIf="activeTab === 'reports'">
    <div class="split-layout">
      <article class="panel">
        <header class="panel-header">
          <div>
            <h3>Faturamento por loja</h3>
            <small>Base para acompanhamento comercial.</small>
          </div>
        </header>
        <div class="table-card compact">
          <table class="data-table">
            <thead>
              <tr>
                <th>Loja</th>
                <th>Vendas</th>
                <th>Faturamento</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of revenueReport">
                <td>{{ row.store_name }}</td>
                <td>{{ row.sales_count || 0 }}</td>
                <td>{{ asCurrency(row.total_amount) }}</td>
              </tr>
              <tr *ngIf="!revenueReport.length">
                <td colspan="3" class="empty-row">Sem dados de faturamento.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </article>

      <article class="panel">
        <header class="panel-header">
          <div>
            <h3>Estoque crítico</h3>
            <small>Itens abaixo do estoque mínimo.</small>
          </div>
        </header>
        <div class="table-card compact">
          <table class="data-table">
            <thead>
              <tr>
                <th>Loja</th>
                <th>Item</th>
                <th>Saldo</th>
                <th>Mínimo</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of stockReport">
                <td>{{ row.store_name }}</td>
                <td>{{ row.item_name }}</td>
                <td>{{ row.balance || 0 }}</td>
                <td>{{ row.minimum_stock || 0 }}</td>
              </tr>
              <tr *ngIf="!stockReport.length">
                <td colspan="4" class="empty-row">Nenhum item crítico.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </article>
    </div>

    <article class="panel">
      <header class="panel-header">
        <div>
          <h3>Vendas por cliente</h3>
          <small>Ranking de clientes por volume vendido.</small>
        </div>
      </header>
      <div class="table-card">
        <table class="data-table">
          <thead>
            <tr>
              <th>Cliente</th>
              <th>Pedidos</th>
              <th>Última venda</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of salesReport">
              <td>{{ row.client_name || 'Consumidor não identificado' }}</td>
              <td>{{ row.sales_count || 0 }}</td>
              <td>{{ row.last_sale_at ? (row.last_sale_at | date:'dd/MM/yyyy HH:mm') : '-' }}</td>
              <td>{{ asCurrency(row.total_amount) }}</td>
            </tr>
            <tr *ngIf="!salesReport.length">
              <td colspan="4" class="empty-row">Sem vendas consolidadas.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </article>
  </section>
</div>

<div class="cp-modal-backdrop" *ngIf="showStoreModal" (click)="closeModal('store')"></div>
<section class="cp-modal cp-modal-fixed-height mystore-modal" *ngIf="showStoreModal" (click)="$event.stopPropagation()">
  <header class="modal-header">
    <div>
      <h2>{{ selectedStore ? 'Editar loja' : 'Nova loja' }}</h2>
      <small>Cadastro de matriz, filial e estrutura física.</small>
    </div>
    <button class="icon" type="button" (click)="closeModal('store')"><mat-icon>close</mat-icon></button>
  </header>
  <form class="cp-modal-body" [formGroup]="storeForm">
    <section class="cp-panel">
      <div class="cp-form-row">
        <mat-form-field appearance="outline" class="cp-field-mat"><mat-label>Código</mat-label><input matInput formControlName="code"></mat-form-field>
        <mat-form-field appearance="outline" class="cp-field-mat"><mat-label>Nome</mat-label><input matInput formControlName="name"></mat-form-field>
        <mat-form-field appearance="outline" class="cp-field-mat">
          <mat-label>Tipo</mat-label>
          <mat-select formControlName="store_type">
            <mat-option value="MATRIX">Matriz</mat-option>
            <mat-option value="BRANCH">Filial</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="cp-field-mat">
          <mat-label>Loja matriz</mat-label>
          <mat-select formControlName="matrix_store_id">
            <mat-option value="">Nenhuma</mat-option>
            <mat-option *ngFor="let store of lookups.stores" [value]="store.id">{{ store.name }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="cp-form-row">
        <mat-form-field appearance="outline" class="cp-field-mat">
          <mat-label>Gerente responsável</mat-label>
          <mat-select formControlName="manager_user_id">
            <mat-option value="">Selecionar</mat-option>
            <mat-option *ngFor="let user of lookups.users" [value]="user.id">{{ user.name }}</mat-option>
          </mat-select>
        </mat-form-field>
        <div class="toggle-wrap">
          <mat-slide-toggle formControlName="active">Loja ativa</mat-slide-toggle>
        </div>
      </div>
      <div class="cp-form-row">
        <mat-form-field appearance="outline" class="cp-field-mat"><mat-label>CEP</mat-label><input matInput formControlName="address_zip"></mat-form-field>
        <mat-form-field appearance="outline" class="cp-field-mat"><mat-label>Rua</mat-label><input matInput formControlName="address_street"></mat-form-field>
        <mat-form-field appearance="outline" class="cp-field-mat"><mat-label>Número</mat-label><input matInput formControlName="address_number"></mat-form-field>
        <mat-form-field appearance="outline" class="cp-field-mat"><mat-label>Complemento</mat-label><input matInput formControlName="address_complement"></mat-form-field>
      </div>
      <div class="cp-form-row">
        <mat-form-field appearance="outline" class="cp-field-mat"><mat-label>Bairro</mat-label><input matInput formControlName="address_neighborhood"></mat-form-field>
        <mat-form-field appearance="outline" class="cp-field-mat"><mat-label>Cidade</mat-label><input matInput formControlName="address_city"></mat-form-field>
        <mat-form-field appearance="outline" class="cp-field-mat"><mat-label>Estado</mat-label><input matInput formControlName="address_state"></mat-form-field>
        <mat-form-field appearance="outline" class="cp-field-mat"><mat-label>País</mat-label><input matInput formControlName="address_country"></mat-form-field>
      </div>
    </section>
  </form>
  <footer class="cp-modal__footer">
    <button mat-stroked-button type="button" (click)="closeModal('store')">Cancelar</button>
    <button mat-raised-button color="primary" type="button" (click)="submitStore()">Salvar loja</button>
  </footer>
</section>

<div class="cp-modal-backdrop" *ngIf="showStoreUsersModal" (click)="closeModal('storeUsers')"></div>
<section class="cp-modal cp-modal-fixed-height mystore-modal" *ngIf="showStoreUsersModal" (click)="$event.stopPropagation()">
  <header class="modal-header">
    <div>
      <h2>Usuários da loja</h2>
      <small>{{ selectedStore?.name }}</small>
    </div>
    <button class="icon" type="button" (click)="closeModal('storeUsers')"><mat-icon>close</mat-icon></button>
  </header>
  <div class="cp-modal-body">
    <section class="cp-panel">
      <div class="cp-form-row" [formGroup]="storeUserForm">
        <mat-form-field appearance="outline" class="cp-field-mat">
          <mat-label>Usuário</mat-label>
          <mat-select formControlName="user_id">
            <mat-option *ngFor="let user of lookups.users" [value]="user.id">{{ user.name }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="cp-field-mat"><mat-label>Perfil na loja</mat-label><input matInput formControlName="role_name"></mat-form-field>
      </div>
      <div class="cp-field-controls" [formGroup]="storeUserForm">
        <mat-slide-toggle formControlName="can_manage">Gerenciar</mat-slide-toggle>
        <mat-slide-toggle formControlName="can_sell">Vender</mat-slide-toggle>
        <mat-slide-toggle formControlName="can_buy">Comprar</mat-slide-toggle>
        <mat-slide-toggle formControlName="can_stock">Estoque</mat-slide-toggle>
        <mat-slide-toggle formControlName="can_cash">Caixa</mat-slide-toggle>
      </div>
      <div class="inline-actions">
        <button mat-raised-button color="primary" type="button" (click)="submitStoreUser()">Vincular usuário</button>
      </div>
    </section>
    <section class="cp-panel">
      <div class="table-card">
        <table class="data-table">
          <thead>
            <tr>
              <th>Usuário</th>
              <th>Perfil</th>
              <th>Permissões</th>
              <th class="actions-col">Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let link of storeUsers">
              <td>{{ link.user_name || link.email || ('#' + link.user_id) }}</td>
              <td>{{ link.role_name }}</td>
              <td>
                {{ link.can_manage ? 'Gerenciar · ' : '' }}{{ link.can_sell ? 'Vender · ' : '' }}{{ link.can_buy ? 'Comprar · ' : '' }}{{ link.can_stock ? 'Estoque · ' : '' }}{{ link.can_cash ? 'Caixa' : '' }}
              </td>
              <td class="actions-col">
                <button mat-stroked-button color="warn" type="button" (click)="deleteStoreUser(link)">Remover</button>
              </td>
            </tr>
            <tr *ngIf="!storeUsers.length">
              <td colspan="4" class="empty-row">Nenhum usuário vinculado.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </div>
</section>

<div class="cp-modal-backdrop" *ngIf="showClientModal" (click)="closeModal('client')"></div>
<section class="cp-modal cp-modal-fixed-height mystore-modal" *ngIf="showClientModal" (click)="$event.stopPropagation()">
  <header class="modal-header">
    <div><h2>{{ selectedClient ? 'Editar cliente' : 'Novo cliente' }}</h2><small>Cadastro comercial e fiscal do cliente.</small></div>
    <button class="icon" type="button" (click)="closeModal('client')"><mat-icon>close</mat-icon></button>
  </header>
  <form class="cp-modal-body" [formGroup]="clientForm">
    <section class="cp-panel">
      <div class="cp-form-row">
        <mat-form-field appearance="outline" class="cp-field-mat"><mat-label>Código</mat-label><input matInput formControlName="code"></mat-form-field>
        <mat-form-field appearance="outline" class="cp-field-mat"><mat-label>Nome</mat-label><input matInput formControlName="name"></mat-form-field>
        <mat-form-field appearance="outline" class="cp-field-mat"><mat-label>Documento</mat-label><input matInput formControlName="document_number"></mat-form-field>
        <mat-form-field appearance="outline" class="cp-field-mat"><mat-label>E-mail</mat-label><input matInput formControlName="email"></mat-form-field>
      </div>
      <div class="cp-form-row">
        <mat-form-field appearance="outline" class="cp-field-mat"><mat-label>Telefone</mat-label><input matInput formControlName="phone"></mat-form-field>
        <mat-form-field appearance="outline" class="cp-field-mat"><mat-label>Celular</mat-label><input matInput formControlName="mobile_phone"></mat-form-field>
        <mat-form-field appearance="outline" class="cp-field-mat"><mat-label>Cidade</mat-label><input matInput formControlName="address_city"></mat-form-field>
        <mat-form-field appearance="outline" class="cp-field-mat"><mat-label>Estado</mat-label><input matInput formControlName="address_state"></mat-form-field>
      </div>
      <mat-form-field appearance="outline" class="cp-field-mat">
        <mat-label>Observações</mat-label>
        <textarea matInput formControlName="notes"></textarea>
      </mat-form-field>
      <div class="toggle-wrap">
        <mat-slide-toggle formControlName="active">Cliente ativo</mat-slide-toggle>
      </div>
    </section>
  </form>
  <footer class="cp-modal__footer">
    <button mat-stroked-button type="button" (click)="closeModal('client')">Cancelar</button>
    <button mat-raised-button color="primary" type="button" (click)="submitClient()">Salvar cliente</button>
  </footer>
</section>

<div class="cp-modal-backdrop" *ngIf="showCategoryModal" (click)="closeModal('category')"></div>
<section class="cp-modal mystore-modal mystore-modal--compact" *ngIf="showCategoryModal" (click)="$event.stopPropagation()">
  <header class="modal-header">
    <div><h2>{{ selectedCategory ? 'Editar categoria' : 'Nova categoria' }}</h2><small>Organização do catálogo.</small></div>
    <button class="icon" type="button" (click)="closeModal('category')"><mat-icon>close</mat-icon></button>
  </header>
  <form class="cp-modal-body" [formGroup]="categoryForm">
    <section class="cp-panel">
      <div class="cp-form-row">
        <mat-form-field appearance="outline" class="cp-field-mat"><mat-label>Nome</mat-label><input matInput formControlName="name"></mat-form-field>
      </div>
      <mat-form-field appearance="outline" class="cp-field-mat">
        <mat-label>Descrição</mat-label>
        <textarea matInput formControlName="description"></textarea>
      </mat-form-field>
      <div class="toggle-wrap">
        <mat-slide-toggle formControlName="active">Categoria ativa</mat-slide-toggle>
      </div>
    </section>
  </form>
  <footer class="cp-modal__footer">
    <button mat-stroked-button type="button" (click)="closeModal('category')">Cancelar</button>
    <button mat-raised-button color="primary" type="button" (click)="submitCategory()">Salvar categoria</button>
  </footer>
</section>

<div class="cp-modal-backdrop" *ngIf="showItemModal" (click)="closeModal('item')"></div>
<section class="cp-modal cp-modal-fixed-height mystore-modal" *ngIf="showItemModal" (click)="$event.stopPropagation()">
  <header class="modal-header">
    <div><h2>{{ selectedItem ? 'Editar item' : 'Novo item' }}</h2><small>Cadastro de produto ou serviço.</small></div>
    <button class="icon" type="button" (click)="closeModal('item')"><mat-icon>close</mat-icon></button>
  </header>
  <form class="cp-modal-body" [formGroup]="itemForm">
    <section class="cp-panel">
      <div class="cp-form-row">
        <mat-form-field appearance="outline" class="cp-field-mat">
          <mat-label>Categoria</mat-label>
          <mat-select formControlName="category_id">
            <mat-option value="">Sem categoria</mat-option>
            <mat-option *ngFor="let category of lookups.categories" [value]="category.id">{{ category.name }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="cp-field-mat"><mat-label>Código</mat-label><input matInput formControlName="code"></mat-form-field>
        <mat-form-field appearance="outline" class="cp-field-mat"><mat-label>Nome</mat-label><input matInput formControlName="name"></mat-form-field>
        <mat-form-field appearance="outline" class="cp-field-mat">
          <mat-label>Tipo</mat-label>
          <mat-select formControlName="item_type">
            <mat-option value="PRODUCT">Produto</mat-option>
            <mat-option value="SERVICE">Serviço</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="cp-form-row">
        <mat-form-field appearance="outline" class="cp-field-mat"><mat-label>SKU</mat-label><input matInput formControlName="sku"></mat-form-field>
        <mat-form-field appearance="outline" class="cp-field-mat"><mat-label>Unidade</mat-label><input matInput formControlName="unit_name"></mat-form-field>
        <mat-form-field appearance="outline" class="cp-field-mat"><mat-label>Custo</mat-label><input matInput type="number" formControlName="cost_price"></mat-form-field>
        <mat-form-field appearance="outline" class="cp-field-mat"><mat-label>Preço de venda</mat-label><input matInput type="number" formControlName="sale_price"></mat-form-field>
      </div>
      <div class="cp-form-row">
        <mat-form-field appearance="outline" class="cp-field-mat"><mat-label>Estoque mínimo</mat-label><input matInput type="number" formControlName="minimum_stock"></mat-form-field>
      </div>
      <div class="cp-field-controls">
        <mat-slide-toggle formControlName="stock_enabled">Controlar estoque</mat-slide-toggle>
        <mat-slide-toggle formControlName="active">Item ativo</mat-slide-toggle>
      </div>
    </section>
  </form>
  <footer class="cp-modal__footer">
    <button mat-stroked-button type="button" (click)="closeModal('item')">Cancelar</button>
    <button mat-raised-button color="primary" type="button" (click)="submitItem()">Salvar item</button>
  </footer>
</section>

<div class="cp-modal-backdrop" *ngIf="showSupplierModal" (click)="closeModal('supplier')"></div>
<section class="cp-modal cp-modal-fixed-height mystore-modal" *ngIf="showSupplierModal" (click)="$event.stopPropagation()">
  <header class="modal-header">
    <div><h2>{{ selectedSupplier ? 'Editar fornecedor' : 'Novo fornecedor' }}</h2><small>Base de suprimentos do módulo.</small></div>
    <button class="icon" type="button" (click)="closeModal('supplier')"><mat-icon>close</mat-icon></button>
  </header>
  <form class="cp-modal-body" [formGroup]="supplierForm">
    <section class="cp-panel">
      <div class="cp-form-row">
        <mat-form-field appearance="outline" class="cp-field-mat"><mat-label>Nome</mat-label><input matInput formControlName="name"></mat-form-field>
        <mat-form-field appearance="outline" class="cp-field-mat"><mat-label>Documento</mat-label><input matInput formControlName="document_number"></mat-form-field>
        <mat-form-field appearance="outline" class="cp-field-mat"><mat-label>E-mail</mat-label><input matInput formControlName="email"></mat-form-field>
        <mat-form-field appearance="outline" class="cp-field-mat"><mat-label>Telefone</mat-label><input matInput formControlName="phone"></mat-form-field>
      </div>
      <div class="cp-form-row">
        <mat-form-field appearance="outline" class="cp-field-mat"><mat-label>Contato</mat-label><input matInput formControlName="contact_name"></mat-form-field>
      </div>
      <mat-form-field appearance="outline" class="cp-field-mat">
        <mat-label>Observações</mat-label>
        <textarea matInput formControlName="notes"></textarea>
      </mat-form-field>
      <div class="toggle-wrap">
        <mat-slide-toggle formControlName="active">Fornecedor ativo</mat-slide-toggle>
      </div>
    </section>
  </form>
  <footer class="cp-modal__footer">
    <button mat-stroked-button type="button" (click)="closeModal('supplier')">Cancelar</button>
    <button mat-raised-button color="primary" type="button" (click)="submitSupplier()">Salvar fornecedor</button>
  </footer>
</section>

<div class="cp-modal-backdrop" *ngIf="showBudgetModal" (click)="closeModal('budget')"></div>
<section class="cp-modal cp-modal-fixed-height mystore-modal" *ngIf="showBudgetModal" (click)="$event.stopPropagation()">
  <header class="modal-header">
    <div><h2>{{ selectedBudget ? 'Editar orçamento' : 'Novo orçamento' }}</h2><small>Monte a proposta e itens do orçamento.</small></div>
    <button class="icon" type="button" (click)="closeModal('budget')"><mat-icon>close</mat-icon></button>
  </header>
  <form class="cp-modal-body" [formGroup]="budgetForm">
    <section class="cp-panel">
      <div class="cp-form-row">
        <mat-form-field appearance="outline" class="cp-field-mat">
          <mat-label>Loja</mat-label>
          <mat-select formControlName="store_id">
            <mat-option *ngFor="let store of lookups.stores" [value]="store.id">{{ store.name }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="cp-field-mat">
          <mat-label>Cliente</mat-label>
          <mat-select formControlName="client_id">
            <mat-option value="">Não informado</mat-option>
            <mat-option *ngFor="let client of lookups.clients" [value]="client.id">{{ client.name }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="cp-field-mat">
          <mat-label>Vendedor</mat-label>
          <mat-select formControlName="seller_user_id">
            <mat-option value="">Selecionar</mat-option>
            <mat-option *ngFor="let user of lookups.users" [value]="user.id">{{ user.name }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="cp-field-mat">
          <mat-label>Status</mat-label>
          <mat-select formControlName="status">
            <mat-option value="DRAFT">Rascunho</mat-option>
            <mat-option value="SENT">Enviado</mat-option>
            <mat-option value="APPROVED">Aprovado</mat-option>
            <mat-option value="REJECTED">Rejeitado</mat-option>
            <mat-option value="CANCELLED">Cancelado</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="cp-form-row">
        <mat-form-field appearance="outline" class="cp-field-mat"><mat-label>Validade</mat-label><input matInput type="date" formControlName="valid_until"></mat-form-field>
      </div>
      <mat-form-field appearance="outline" class="cp-field-mat">
        <mat-label>Observações</mat-label>
        <textarea matInput formControlName="notes"></textarea>
      </mat-form-field>
    </section>

    <section class="cp-panel">
      <header class="panel-header">
        <div><h3>Itens do orçamento</h3><small>Descreva os itens para cálculo do total.</small></div>
        <button mat-stroked-button type="button" (click)="addBudgetItem()">Adicionar item</button>
      </header>
      <div formArrayName="items" class="line-items">
        <div class="line-item" *ngFor="let item of budgetItems.controls; let i = index" [formGroupName]="i">
          <div class="cp-form-row">
            <mat-form-field appearance="outline" class="cp-field-mat">
              <mat-label>Item</mat-label>
              <mat-select formControlName="item_id">
                <mat-option value="">Livre</mat-option>
                <mat-option *ngFor="let lookupItem of lookups.items" [value]="lookupItem.id">{{ lookupItem.name }}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" class="cp-field-mat"><mat-label>Descrição</mat-label><input matInput formControlName="description"></mat-form-field>
            <mat-form-field appearance="outline" class="cp-field-mat"><mat-label>Quantidade</mat-label><input matInput type="number" formControlName="quantity"></mat-form-field>
            <mat-form-field appearance="outline" class="cp-field-mat"><mat-label>Valor unitário</mat-label><input matInput type="number" formControlName="unit_price"></mat-form-field>
            <mat-form-field appearance="outline" class="cp-field-mat"><mat-label>Desconto</mat-label><input matInput type="number" formControlName="discount_amount"></mat-form-field>
          </div>
          <div class="line-item__actions">
            <button mat-stroked-button color="warn" type="button" (click)="removeBudgetItem(i)">Remover item</button>
          </div>
        </div>
      </div>
    </section>
  </form>
  <footer class="cp-modal__footer">
    <button mat-stroked-button type="button" (click)="closeModal('budget')">Cancelar</button>
    <button mat-raised-button color="primary" type="button" (click)="submitBudget()">Salvar orçamento</button>
  </footer>
</section>

<div class="cp-modal-backdrop" *ngIf="showSaleModal" (click)="closeModal('sale')"></div>
<section class="cp-modal cp-modal-fixed-height mystore-modal" *ngIf="showSaleModal" (click)="$event.stopPropagation()">
  <header class="modal-header">
    <div><h2>{{ selectedSale ? 'Editar venda' : 'Nova venda' }}</h2><small>Venda com itens, origem e pagamentos.</small></div>
    <button class="icon" type="button" (click)="closeModal('sale')"><mat-icon>close</mat-icon></button>
  </header>
  <form class="cp-modal-body" [formGroup]="saleForm">
    <section class="cp-panel">
      <div class="cp-form-row">
        <mat-form-field appearance="outline" class="cp-field-mat">
          <mat-label>Loja</mat-label>
          <mat-select formControlName="store_id">
            <mat-option *ngFor="let store of lookups.stores" [value]="store.id">{{ store.name }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="cp-field-mat">
          <mat-label>Cliente</mat-label>
          <mat-select formControlName="client_id">
            <mat-option value="">Não informado</mat-option>
            <mat-option *ngFor="let client of lookups.clients" [value]="client.id">{{ client.name }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="cp-field-mat">
          <mat-label>Vendedor</mat-label>
          <mat-select formControlName="seller_user_id">
            <mat-option value="">Selecionar</mat-option>
            <mat-option *ngFor="let user of lookups.users" [value]="user.id">{{ user.name }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="cp-field-mat">
          <mat-label>Origem do orçamento</mat-label>
          <mat-select formControlName="source_budget_id">
            <mat-option value="">Sem origem</mat-option>
            <mat-option *ngFor="let budget of budgets" [value]="budget.id">{{ budget.code || ('#' + budget.id) }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="cp-form-row">
        <mat-form-field appearance="outline" class="cp-field-mat">
          <mat-label>Status</mat-label>
          <mat-select formControlName="status">
            <mat-option value="OPEN">Aberta</mat-option>
            <mat-option value="PARTIAL">Parcial</mat-option>
            <mat-option value="PAID">Paga</mat-option>
            <mat-option value="CANCELLED">Cancelada</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="cp-field-mat"><mat-label>Data da venda</mat-label><input matInput type="datetime-local" formControlName="sold_at"></mat-form-field>
      </div>
      <mat-form-field appearance="outline" class="cp-field-mat">
        <mat-label>Observações</mat-label>
        <textarea matInput formControlName="notes"></textarea>
      </mat-form-field>
    </section>

    <section class="cp-panel">
      <header class="panel-header">
        <div><h3>Itens da venda</h3><small>Produtos e serviços comercializados.</small></div>
        <button mat-stroked-button type="button" (click)="addSaleItem()">Adicionar item</button>
      </header>
      <div formArrayName="items" class="line-items">
        <div class="line-item" *ngFor="let item of saleItems.controls; let i = index" [formGroupName]="i">
          <div class="cp-form-row">
            <mat-form-field appearance="outline" class="cp-field-mat">
              <mat-label>Item</mat-label>
              <mat-select formControlName="item_id">
                <mat-option value="">Livre</mat-option>
                <mat-option *ngFor="let lookupItem of lookups.items" [value]="lookupItem.id">{{ lookupItem.name }}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" class="cp-field-mat"><mat-label>Descrição</mat-label><input matInput formControlName="description"></mat-form-field>
            <mat-form-field appearance="outline" class="cp-field-mat"><mat-label>Quantidade</mat-label><input matInput type="number" formControlName="quantity"></mat-form-field>
            <mat-form-field appearance="outline" class="cp-field-mat"><mat-label>Valor unitário</mat-label><input matInput type="number" formControlName="unit_price"></mat-form-field>
            <mat-form-field appearance="outline" class="cp-field-mat"><mat-label>Desconto</mat-label><input matInput type="number" formControlName="discount_amount"></mat-form-field>
          </div>
          <div class="line-item__actions">
            <button mat-stroked-button color="warn" type="button" (click)="removeSaleItem(i)">Remover item</button>
          </div>
        </div>
      </div>
    </section>

    <section class="cp-panel">
      <header class="panel-header">
        <div><h3>Pagamentos da venda</h3><small>Pagamentos já recebidos ou previstos.</small></div>
        <button mat-stroked-button type="button" (click)="addSalePaymentLine()">Adicionar pagamento</button>
      </header>
      <div formArrayName="payments" class="line-items">
        <div class="line-item" *ngFor="let payment of salePayments.controls; let i = index" [formGroupName]="i">
          <div class="cp-form-row">
            <mat-form-field appearance="outline" class="cp-field-mat">
              <mat-label>Método</mat-label>
              <mat-select formControlName="payment_method">
                <mat-option value="PIX">PIX</mat-option>
                <mat-option value="CARD">Cartão</mat-option>
                <mat-option value="CASH">Dinheiro</mat-option>
                <mat-option value="TRANSFER">Transferência</mat-option>
                <mat-option value="BANK_SLIP">Boleto</mat-option>
                <mat-option value="OTHER">Outro</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" class="cp-field-mat"><mat-label>Valor</mat-label><input matInput type="number" formControlName="amount"></mat-form-field>
            <mat-form-field appearance="outline" class="cp-field-mat"><mat-label>Pago em</mat-label><input matInput type="datetime-local" formControlName="paid_at"></mat-form-field>
            <mat-form-field appearance="outline" class="cp-field-mat"><mat-label>Observações</mat-label><input matInput formControlName="notes"></mat-form-field>
          </div>
          <div class="line-item__actions">
            <button mat-stroked-button color="warn" type="button" (click)="removeSalePaymentLine(i)">Remover pagamento</button>
          </div>
        </div>
      </div>
    </section>
  </form>
  <footer class="cp-modal__footer">
    <button mat-stroked-button type="button" (click)="closeModal('sale')">Cancelar</button>
    <button mat-raised-button color="primary" type="button" (click)="submitSale()">Salvar venda</button>
  </footer>
</section>

<div class="cp-modal-backdrop" *ngIf="showPurchaseModal" (click)="closeModal('purchase')"></div>
<section class="cp-modal cp-modal-fixed-height mystore-modal" *ngIf="showPurchaseModal" (click)="$event.stopPropagation()">
  <header class="modal-header">
    <div><h2>{{ selectedPurchase ? 'Editar compra' : 'Nova compra' }}</h2><small>Compras por fornecedor e entrada de estoque.</small></div>
    <button class="icon" type="button" (click)="closeModal('purchase')"><mat-icon>close</mat-icon></button>
  </header>
  <form class="cp-modal-body" [formGroup]="purchaseForm">
    <section class="cp-panel">
      <div class="cp-form-row">
        <mat-form-field appearance="outline" class="cp-field-mat">
          <mat-label>Loja</mat-label>
          <mat-select formControlName="store_id">
            <mat-option *ngFor="let store of lookups.stores" [value]="store.id">{{ store.name }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="cp-field-mat">
          <mat-label>Fornecedor</mat-label>
          <mat-select formControlName="supplier_id">
            <mat-option value="">Selecionar</mat-option>
            <mat-option *ngFor="let supplier of lookups.suppliers" [value]="supplier.id">{{ supplier.name }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="cp-field-mat">
          <mat-label>Comprador</mat-label>
          <mat-select formControlName="buyer_user_id">
            <mat-option value="">Selecionar</mat-option>
            <mat-option *ngFor="let user of lookups.users" [value]="user.id">{{ user.name }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="cp-field-mat">
          <mat-label>Status</mat-label>
          <mat-select formControlName="status">
            <mat-option value="OPEN">Aberta</mat-option>
            <mat-option value="PARTIAL">Parcial</mat-option>
            <mat-option value="RECEIVED">Recebida</mat-option>
            <mat-option value="CANCELLED">Cancelada</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="cp-form-row">
        <mat-form-field appearance="outline" class="cp-field-mat"><mat-label>Data da compra</mat-label><input matInput type="datetime-local" formControlName="purchased_at"></mat-form-field>
      </div>
      <mat-form-field appearance="outline" class="cp-field-mat">
        <mat-label>Observações</mat-label>
        <textarea matInput formControlName="notes"></textarea>
      </mat-form-field>
    </section>

    <section class="cp-panel">
      <header class="panel-header">
        <div><h3>Itens da compra</h3><small>Itens adquiridos e custo unitário.</small></div>
        <button mat-stroked-button type="button" (click)="addPurchaseItem()">Adicionar item</button>
      </header>
      <div formArrayName="items" class="line-items">
        <div class="line-item" *ngFor="let item of purchaseItems.controls; let i = index" [formGroupName]="i">
          <div class="cp-form-row">
            <mat-form-field appearance="outline" class="cp-field-mat">
              <mat-label>Item</mat-label>
              <mat-select formControlName="item_id">
                <mat-option value="">Livre</mat-option>
                <mat-option *ngFor="let lookupItem of lookups.items" [value]="lookupItem.id">{{ lookupItem.name }}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" class="cp-field-mat"><mat-label>Descrição</mat-label><input matInput formControlName="description"></mat-form-field>
            <mat-form-field appearance="outline" class="cp-field-mat"><mat-label>Quantidade</mat-label><input matInput type="number" formControlName="quantity"></mat-form-field>
            <mat-form-field appearance="outline" class="cp-field-mat"><mat-label>Custo unitário</mat-label><input matInput type="number" formControlName="unit_cost"></mat-form-field>
            <mat-form-field appearance="outline" class="cp-field-mat"><mat-label>Desconto</mat-label><input matInput type="number" formControlName="discount_amount"></mat-form-field>
          </div>
          <div class="line-item__actions">
            <button mat-stroked-button color="warn" type="button" (click)="removePurchaseItem(i)">Remover item</button>
          </div>
        </div>
      </div>
    </section>
  </form>
  <footer class="cp-modal__footer">
    <button mat-stroked-button type="button" (click)="closeModal('purchase')">Cancelar</button>
    <button mat-raised-button color="primary" type="button" (click)="submitPurchase()">Salvar compra</button>
  </footer>
</section>

<div class="cp-modal-backdrop" *ngIf="showStockMovementModal" (click)="closeModal('stock')"></div>
<section class="cp-modal mystore-modal mystore-modal--compact" *ngIf="showStockMovementModal" (click)="$event.stopPropagation()">
  <header class="modal-header">
    <div><h2>Movimentação de estoque</h2><small>Entrada, saída ou ajuste de saldo.</small></div>
    <button class="icon" type="button" (click)="closeModal('stock')"><mat-icon>close</mat-icon></button>
  </header>
  <form class="cp-modal-body" [formGroup]="stockMovementForm">
    <section class="cp-panel">
      <div class="cp-form-row">
        <mat-form-field appearance="outline" class="cp-field-mat">
          <mat-label>Loja</mat-label>
          <mat-select formControlName="store_id">
            <mat-option *ngFor="let store of lookups.stores" [value]="store.id">{{ store.name }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="cp-field-mat">
          <mat-label>Item</mat-label>
          <mat-select formControlName="item_id">
            <mat-option *ngFor="let item of lookups.items" [value]="item.id">{{ item.name }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="cp-field-mat">
          <mat-label>Tipo</mat-label>
          <mat-select formControlName="movement_type">
            <mat-option value="ENTRY">Entrada</mat-option>
            <mat-option value="EXIT">Saída</mat-option>
            <mat-option value="ADJUSTMENT">Ajuste</mat-option>
            <mat-option value="RETURN">Devolução</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="cp-field-mat"><mat-label>Quantidade</mat-label><input matInput type="number" formControlName="quantity"></mat-form-field>
      </div>
      <div class="cp-form-row">
        <mat-form-field appearance="outline" class="cp-field-mat"><mat-label>Custo unitário</mat-label><input matInput type="number" formControlName="unit_cost"></mat-form-field>
      </div>
      <mat-form-field appearance="outline" class="cp-field-mat">
        <mat-label>Observações</mat-label>
        <textarea matInput formControlName="notes"></textarea>
      </mat-form-field>
    </section>
  </form>
  <footer class="cp-modal__footer">
    <button mat-stroked-button type="button" (click)="closeModal('stock')">Cancelar</button>
    <button mat-raised-button color="primary" type="button" (click)="submitStockMovement()">Salvar movimento</button>
  </footer>
</section>

<div class="cp-modal-backdrop" *ngIf="showCashSessionModal" (click)="closeModal('cash')"></div>
<section class="cp-modal mystore-modal mystore-modal--compact" *ngIf="showCashSessionModal" (click)="$event.stopPropagation()">
  <header class="modal-header">
    <div><h2>Abertura de caixa</h2><small>Inicie o caixa diário por loja.</small></div>
    <button class="icon" type="button" (click)="closeModal('cash')"><mat-icon>close</mat-icon></button>
  </header>
  <form class="cp-modal-body" [formGroup]="cashSessionForm">
    <section class="cp-panel">
      <div class="cp-form-row">
        <mat-form-field appearance="outline" class="cp-field-mat">
          <mat-label>Loja</mat-label>
          <mat-select formControlName="store_id">
            <mat-option *ngFor="let store of lookups.stores" [value]="store.id">{{ store.name }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="cp-field-mat"><mat-label>Valor de abertura</mat-label><input matInput type="number" formControlName="opening_amount"></mat-form-field>
      </div>
      <mat-form-field appearance="outline" class="cp-field-mat">
        <mat-label>Observações</mat-label>
        <textarea matInput formControlName="notes"></textarea>
      </mat-form-field>
    </section>
  </form>
  <footer class="cp-modal__footer">
    <button mat-stroked-button type="button" (click)="closeModal('cash')">Cancelar</button>
    <button mat-raised-button color="primary" type="button" (click)="submitCashSession()">Abrir caixa</button>
  </footer>
</section>

<div class="cp-modal-backdrop" *ngIf="showCashMovementModal" (click)="closeModal('cashMovement')"></div>
<section class="cp-modal cp-modal-fixed-height mystore-modal" *ngIf="showCashMovementModal" (click)="$event.stopPropagation()">
  <header class="modal-header">
    <div><h2>Movimentações do caixa</h2><small>{{ selectedCashSession?.store_name }}</small></div>
    <button class="icon" type="button" (click)="closeModal('cashMovement')"><mat-icon>close</mat-icon></button>
  </header>
  <div class="cp-modal-body">
    <section class="cp-panel" [formGroup]="cashMovementForm">
      <div class="cp-form-row">
        <mat-form-field appearance="outline" class="cp-field-mat">
          <mat-label>Tipo</mat-label>
          <mat-select formControlName="movement_type">
            <mat-option value="IN">Entrada</mat-option>
            <mat-option value="OUT">Saída</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="cp-field-mat"><mat-label>Categoria</mat-label><input matInput formControlName="category"></mat-form-field>
        <mat-form-field appearance="outline" class="cp-field-mat"><mat-label>Valor</mat-label><input matInput type="number" formControlName="amount"></mat-form-field>
        <mat-form-field appearance="outline" class="cp-field-mat"><mat-label>Data</mat-label><input matInput type="datetime-local" formControlName="moved_at"></mat-form-field>
      </div>
      <mat-form-field appearance="outline" class="cp-field-mat">
        <mat-label>Observações</mat-label>
        <textarea matInput formControlName="notes"></textarea>
      </mat-form-field>
      <div class="inline-actions">
        <button mat-raised-button color="primary" type="button" (click)="submitCashMovement()">Registrar movimento</button>
      </div>
    </section>
    <section class="cp-panel">
      <div class="table-card">
        <table class="data-table">
          <thead>
            <tr>
              <th>Data</th>
              <th>Tipo</th>
              <th>Categoria</th>
              <th>Valor</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of cashMovements">
              <td>{{ row.moved_at ? (row.moved_at | date:'dd/MM/yyyy HH:mm') : (row.created_at | date:'dd/MM/yyyy HH:mm') }}</td>
              <td>{{ row.movement_type === 'IN' ? 'Entrada' : 'Saída' }}</td>
              <td>{{ row.category }}</td>
              <td>{{ asCurrency(row.amount) }}</td>
            </tr>
            <tr *ngIf="!cashMovements.length">
              <td colspan="4" class="empty-row">Nenhuma movimentação registrada neste caixa.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </div>
</section>

<div class="cp-modal-backdrop" *ngIf="showPaymentModal" (click)="closeModal('payment')"></div>
<section class="cp-modal mystore-modal mystore-modal--compact" *ngIf="showPaymentModal" (click)="$event.stopPropagation()">
  <header class="modal-header">
    <div><h2>Novo pagamento</h2><small>Registrar recebimento da venda.</small></div>
    <button class="icon" type="button" (click)="closeModal('payment')"><mat-icon>close</mat-icon></button>
  </header>
  <form class="cp-modal-body" [formGroup]="paymentForm">
    <section class="cp-panel">
      <div class="cp-form-row">
        <mat-form-field appearance="outline" class="cp-field-mat">
          <mat-label>Método</mat-label>
          <mat-select formControlName="payment_method">
            <mat-option value="PIX">PIX</mat-option>
            <mat-option value="CARD">Cartão</mat-option>
            <mat-option value="CASH">Dinheiro</mat-option>
            <mat-option value="TRANSFER">Transferência</mat-option>
            <mat-option value="BANK_SLIP">Boleto</mat-option>
            <mat-option value="OTHER">Outro</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="cp-field-mat"><mat-label>Valor</mat-label><input matInput type="number" formControlName="amount"></mat-form-field>
        <mat-form-field appearance="outline" class="cp-field-mat"><mat-label>Pago em</mat-label><input matInput type="datetime-local" formControlName="paid_at"></mat-form-field>
      </div>
      <mat-form-field appearance="outline" class="cp-field-mat">
        <mat-label>Observações</mat-label>
        <textarea matInput formControlName="notes"></textarea>
      </mat-form-field>
    </section>
  </form>
  <footer class="cp-modal__footer">
    <button mat-stroked-button type="button" (click)="closeModal('payment')">Cancelar</button>
    <button mat-raised-button color="primary" type="button" (click)="submitPayment()">Registrar pagamento</button>
  </footer>
</section>
